module.exports = __webpack_public_path__ + "static/upsell-4-0c44552bedf69e45598bc1747c1536ca.png";